import { NotificationHubConfig } from './types/main';

let notificationHubConfig: NotificationHubConfig = {
    url: undefined,
    icon: undefined,
    audio: undefined,
    expires_in: undefined,
};

export const setupNotificationHubConfig = (data: Partial<NotificationHubConfig>): void => {
    notificationHubConfig = {
        ...notificationHubConfig,
        ...data,
    };
};

export const getNotificationHubConfigUrl = (): string => {
    if (notificationHubConfig.url !== undefined) {
        return `${notificationHubConfig.url}`;
    }

    return '';
};

export const getNotificationHubConfig = (): NotificationHubConfig => notificationHubConfig;
